import React, {useContext} from "react"
import WishListContext from "../../context/WishListContext"
import BikesCollectionItem from "../bikesCollection/BikesCollectionItem/BikesCollectionItem"
import Typography from "../reusable/Typography/Typography"
import {useTranslation} from "next-i18next"
import Spinner from "../reusable/Spinner"
import CreditCheckWishList from "./CreditCheckWishList"
import EmptyWishListLinks from "./EmptyWishListLinks"
import EmptyWishListRightSide from "./EmptyWishListRightSide"
import AnimationComponent from "../reusable/components/AnimationComponent/AnimationComponent"
import LayoutContext from "../../context/LayoutContext"

function WishListProducts() {
	const {wishList, wishListFetchedFromFirestore} = useContext(WishListContext)
	const {isMobile} = useContext(LayoutContext)
	const {t} = useTranslation()
	if (wishList?.length) {
		return (<>
			<div className={`${wishList.length >= 4 ? "container wishlist-container" : "container d-none d-md-flex gap-4 relative justify-content-start"}`}>
				{wishList.length ? wishList.map((bike, idx) => <React.Fragment key={idx}>
					{idx === 3 ? (
						<CreditCheckWishList isListView={false} />
					) : null}
					<BikesCollectionItem isCarouselElement={true}
						isWishList
						key={idx}
						cardWidth="300px"
						bike={bike} /></React.Fragment>
				) : null}
			</div>
			<div className="container wishlist-container-mobile">
				{wishList.map((bike, idx) => (
					<React.Fragment key={idx}>
						{idx === 2 ? (
							<CreditCheckWishList isListView={true} />
						) : null}
						<BikesCollectionItem
							key={idx}
							bike={bike}
							cardWidth="163px"
							isWishList
							isTwoCardsView={true}
							isRowForMobile={true}
						/>
					</React.Fragment>
				))}
			</div>
		</>
		)
	}

	if (wishListFetchedFromFirestore) {
		return (<div style={{rowGap: "16px"}}
			className="container col-12 d-flex flex-column align-items-start justify-content-start">
			<Typography className="text-dark"
				variant="bodySm"
				style={{fontSize: isMobile ? "14px" : "16px", lineHeight: isMobile ? "20px" : "24px"}}>{t("no-wishlist-available")}</Typography>

			<div className="d-flex flex-column col-12 flex-lg-wrap flex-lg-row gap-4 justify-content-lg-center justify-content-start align-items-start">
				<AnimationComponent type="slideRight"
					inProp={true}>
					<EmptyWishListLinks />
				</AnimationComponent>
				<EmptyWishListRightSide />
			</div>
		</div>)
	}

	return <Spinner />
}

export default WishListProducts
